import { gate } from 'hub-http/gates';
import { useMemo } from 'react';
import { useGetHasGate } from '../../user';
export const usePortalType = () => {
  const {
    hasGate,
    loading
  } = useGetHasGate();
  const portalType = useMemo(() => {
    const hasGateResult = !loading ? hasGate(gate('CRM:Pipelines:CRMObjectBoardCard:NewPortals')) : false;
    return hasGateResult ? 'NEW' : 'EXISTING';
  }, [hasGate, loading]);
  return portalType;
};